import { useTranslation } from "react-i18next";


const TrackPopup = ({ handleTrack, confirmBtnCallBack, deleteRecord, message, heading }) => {

    const { t } = useTranslation()

    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg" style={{ width: '50vw' }}>
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">

                                {t('EncroachmentDashboard.Track')}
                                {/* Forward */}
                            </h5>
                            <button onClick={() => handleTrack()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ height: '70vh', overflow: 'auto' }}>
                            <div className="row">
                                <div className="col-12">


                                    <div class="order-track">
                                        <div class="order-track-step">
                                            <div class="order-track-status">
                                                <span class="order-track-status-dot text-center pt-1 fw-bold text-white">
                                                    <i class="fa-solid fa-check"></i>
                                                </span>
                                                <span class="order-track-status-line"></span>
                                            </div>
                                            <div class="order-track-text">
                                                <p class="order-track-text-stat">{t('EncroachmentDashboard.OfficerName')}- Akash</p>
                                                <span class="order-track-text-sub">

                                                    {t('EncroachmentDashboard.ComplaintUploadDate')} - 21st November, 2019
                                                </span>
                                            </div>
                                        </div>
                                        <div class="order-track-step">
                                            <div class="order-track-status">
                                                <span class="order-track-status-dot"></span>
                                                <span class="order-track-status-line"></span>
                                            </div>
                                            <div class="order-track-text">
                                                <p class="order-track-text-stat">{t('EncroachmentDashboard.OfficerName')}- Akash</p>
                                                <span class="order-track-text-sub">

                                                    {t('EncroachmentDashboard.ComplaintReceivedDate')} - 21st November, 2019
                                                </span>
                                            </div>
                                        </div>
                                        <div class="order-track-step">
                                            <div class="order-track-status">
                                                <span class="order-track-status-dot"></span>
                                                <span class="order-track-status-line"></span>
                                            </div>
                                            <div class="order-track-text">
                                                <p class="order-track-text-stat">{t('EncroachmentDashboard.OfficerName')}- Akash</p>
                                                <span class="order-track-text-sub">

                                                    {t('EncroachmentDashboard.AcknowledgedDate')} - 21st November, 2019
                                                </span>
                                            </div>
                                        </div>
                                        <div class="order-track-step">
                                            <div class="order-track-status">
                                                <span class="order-track-status-dot"></span>
                                                <span class="order-track-status-line"></span>
                                            </div>
                                            <div class="order-track-text">
                                                <p class="order-track-text-stat">{t('EncroachmentDashboard.OfficerName')}- Akash</p>
                                                <span class="order-track-text-sub">

                                                    {t('EncroachmentDashboard.ComplaintScheduleDate')} - 21st November, 2019
                                                </span>
                                            </div>
                                        </div>
                                        <div class="order-track-step">
                                            <div class="order-track-status">
                                                <span class="order-track-status-dot"></span>
                                                <span class="order-track-status-line"></span>
                                            </div>
                                            <div class="order-track-text">
                                                <p class="order-track-text-stat">{t('EncroachmentDashboard.OfficerName')}- Akash</p>
                                                <span class="order-track-text-sub">

                                                    {t('EncroachmentDashboard.ComplaintCloseDate')} - 21st November, 2019
                                                </span>
                                            </div>

                                        </div>

                                        <span >


                                        </span>
                                    </div>

                                </div>



                            </div>
                        </div>
                        <div className="moda-footer text-end">
                            <div className="row">
                                <div className="col-12 pt-3">
                                    {/* <button
                                            type='button'
                                            className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                         
                                            {t('EncroachmentDashboard.Forward')}
                                        </button> */}
                                    <button
                                        type="button"
                                        onClick={handleTrack}
                                        className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>);
}

export default TrackPopup;